import React    from 'react';
import JobList  from '../components/JobList';

export default class Job extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            tabList: ['Все вакансии', 'Финансы', 'Управление', 'Креатив', 'Разработка'],
            tabType: 0
        };
    }

    tabFilter (index) {
        this.setState({
            tabType: index
        });
    }

    renderTabList = (item, index) => {
        let tabType = this.state.tabType;

        return (
            <li key={index} className={tabType === index ? 'active' : null} onClick={this.tabFilter.bind(this, index)}><span>{item}</span></li>
        )
    };

    render() {

        const { lang } = this.props;
        const { tabList, tabType } = this.state;

        return (
            <div key="Partners" className="page page-partners">
                <div className="s-job">
                    <div className="job-head">
                        <div className="container">
                            <div className="job-info">
                                <h1 className="s-index__title">{lang.Career}</h1>
                                <ul className="list-unstyled clearfix tab-list">
                                    {tabList.map(this.renderTabList)}
                                </ul>
                            </div>

                            <div className="job-desc row">
                                <div className="col-9">
                                    <p className="desc">
                                        {lang.Job_desc_1_page}
                                    </p>
                                    <p className="desc">
                                        {lang.Job_desc_2_page}
                                    </p>
                                </div>
                                <div className="col-3">
                                    <div className="job-links">
                                        <a href="#" className="link">{lang.Job_links_link}</a>
                                        <span className="offer">{lang.Job_links_offer}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <JobList tabType={tabType} />
                </div>
            </div>
        );
    }
}